import React, { useEffect, useState } from "react";
import { Button, FormFieldSet, NewTab, PageTab } from "../../../../components";
import MarketPlaceAccounts from "./MarketPlaceAccounts";
import MarketPlaceInsights from "./MarketPlaceInsights";

import { useNavigate } from "react-router-dom";
import VideoInterview from "./VideoInterview";
import Vms from "./Vms";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../../../redux/slices/auth/authSelectors";
import { usePortalNavigation } from "../../../../hooks";

const MarketPlaceTabs = ({
  onClose,
  category,
  type,
  integrations,
  onUpdate,
}) => {
  const isLogin = useSelector(selectIsAuthenticated);
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const { portalValue, getDefaultRouteForCurrentPortal } = usePortalNavigation( isLogin, currentUserDetails );

  const navigate = useNavigate();
  const [moduleoption, setModuleOptions] = useState([]);
  const [selectedModule, setSelectedModule] = useState(portalValue);

  const tabList = [
    {
      title: "Insights",
      page: <MarketPlaceInsights
              category={category}
              type={type}
              selectedModule={selectedModule}
            />,
      type: "main",
      id: "marketplace_insights",
    },
    {
      title: "Accounts",
      page: (
        <MarketPlaceAccounts
          category={category}
          type={type}
          integrations={integrations}
          onUpdate={onUpdate}
          selectedModule={selectedModule}
        />
      ),
      type: "main",
      id: "marketplace_accounts",
    },
    {
      title: (
        <div className="w-[160px]">
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Select"
            size="sm"
            options={moduleoption}
            value={selectedModule}
            onChange={(value) => setSelectedModule(value)}
          />
        </div>
      ),
      page: null,
      type: "sub",
      id: "marketplace_search_filter",
    },
  ];

  useEffect(() => {
    if (currentUserDetails?.data?.role?.module === 1) {
      setModuleOptions([
        { label: "ATS", value: "ats" },
        { label: "Bench Sales", value: "bs" },
        { label: "Non-IT Marketing", value: "nm" }

      ])
    } else if (portalValue === "ats") {
      setModuleOptions([ { label: "ATS", value: "ats" } ])
    } else if (portalValue === "bs") {
      setModuleOptions([ { label: "Bench Sales", value: "bs" } ])
    } else if (portalValue === "nm") {
      setModuleOptions([ { label: "Non-IT Marketing", value: "nm" } ])
    }
    setSelectedModule(portalValue);
  }, [currentUserDetails?.data, portalValue]);

  const renderContent = () => {
    switch (category) {
      case 1:
        return (
          <div className="my-5 flex flex-col gap-2">
            <NewTab tabs={tabList} color="black" variant="text" />
          </div>
        );
      case 2:
        return (
          <div className=" flex flex-col gap-2">
            <Vms category={category} type={type} selectedModule={selectedModule} />
          </div>
        );
      case 3:
        return (
          <div className="my-5 flex flex-col gap-2">
            <NewTab tabs={tabList} color="black" variant="text" />
          </div>
        );
      case 6:
        return (
          <div className="my-5 flex flex-col gap-2">
            <NewTab tabs={tabList} color="black" variant="text" />
          </div>
        );

      case 7:
        return (
          <div className="my-5 flex flex-col gap-2">
            <PageTab tabs={tabList} color="black" variant="text" />
          </div>
        );

      // if later you want to handle other categories
      case 9:
        return (
          <div className="my-2 flex flex-col gap-2">
            <VideoInterview category={category} type={type} selectedModule={selectedModule} />
          </div>
        );
      case 11:
        return (
          <div className="my-2 flex flex-col gap-2">
            <NewTab tabs={tabList} color="black" variant="text" />
          </div>
        );
      case 12:
        return (
          <div className="my-2 flex flex-col gap-2">
            <NewTab tabs={tabList} color="black" variant="text" />
          </div>
        );

      default:
        if (selectedModule === "bs") {
          return (
              <div className="mt-3">
                <p>This feature is not available for Bench Sales. However you can configure below features.</p>
                <div className="ms-3">
                  <h6 className="text-dark my-2 -ms-1">Available features for Bench Sales:</h6>
                  <p>1. Kult AI (Text) - {`Marketplace > AI (Beta) > Kult AI (Text) > Setup/Configure`} </p>
                  <p>2. Apollo - {`Marketplace > Productivity > Apollo > Setup/Configure`} </p>
                  <p>3. G-suite - {`Marketplace > Bulk Email > G-suite > Setup/Configure`} </p>
                  <p>4. Outlook - {`Marketplace > Bulk Email > Outlook> Setup/Configure`} </p>
                </div>
              </div>
            )
        }
        return (
          <div className="my-2 mt-5 text-center text-danger">
            You Dont have access. Please Contact Admin
          </div>
        );
    }
  };

  return (
    <div>
      <div>
        <Button
          title="Marketplace"
          color="black"
          variant="text"
          size="lg"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-lg font-semibold !px-0 !py-0"
          onClick={() => navigate("/marketplace")}
        />
      </div>
      <div className="my-3 flex flex-col gap-2">{renderContent()}</div>
    </div>
  );
};

export default MarketPlaceTabs;
